var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMacOssvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    height: 13,
    stroke: "none",
    viewBox: "0 0 13 13",
    width: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.22772.998535c.08269 1.622085-.73005 2.765475-2.30902 2.886255.05388-1.67792.93767-2.52585 2.30902-2.886255z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.2981 7.23772c0-1.01105.5295-1.8983 1.3261-2.40008-.7103-.74442-1.3956-1.2204-2.58884-1.09719-.70985.07327-1.29327.47716-1.92417.48103-1.19051.00733-2.05671-.73934-3.22299-.28862-1.09857.42458-1.78578 1.72199-1.87608 2.98247-.15472 2.15979.90763 4.64637 2.06849 5.62817.20409.1726.61086.3868.86586.4329.69574.126 1.12359-.3229 1.87608-.4329 1.02448-.1498 1.76314.551 2.64573.4329 1.36992-.1833 2.02382-2.0769 2.49342-3.15652-.9812-.4457-1.6636-1.4342-1.6636-2.58216z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacOssvg);
export default __webpack_public_path__ + "static/media/MacOSSVG.ee736758.svg";
export { ForwardRef as ReactComponent };